import { Input } from "antd";
import { type ChangeEvent, useEffect, useState } from "react";

type Props = {
  isEditMode: boolean;
  defaultValue: number;
  onSave: (value: number | null) => Promise<void>;
  min: number;
};

const NumberEditableColumn = ({ isEditMode, defaultValue, onSave, min }: Props) => {
  const [value, setValue] = useState<number | null>(defaultValue);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  const handleSave = async () => {
    setLoading(true);
    try {
      await onSave(value);
    } finally {
      setLoading(false);
    }
  };

  if (isEditMode) {
    return (
      <Input
        onBlur={handleSave}
        disabled={loading}
        style={{ width: "100%" }}
        maxLength={30}
        onPressEnter={handleSave}
        defaultValue={defaultValue}
        value={value ?? ""}
        type="number"
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          const inputValue = e.currentTarget.value;
          setValue(inputValue ? Number(inputValue) : null);
        }}
        min={min}
      />
    );
  }
  return defaultValue;
};

export default NumberEditableColumn;
